/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable sonarjs/no-duplicate-string */
import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import ButtonStyles from "../../styles/components/ButtonStyles";
import Dialog from "../../components/Dialog";
import DialogMessage from "../../components/DialogMessage";

import { StyledInfoLabel } from "../../styles/pages/Schedule/ModalViewDetailsStyles";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";
import DialogStyles from "../../styles/components/DialogStyles";
import InputLabelTextArea from "../../components/InputLabelTextArea";
import { axiosPutRequest } from "../../api/ApiClient";

const { StyledModalTitle, StyledContainerButton, StyledModalText } =
    DialogStyles;

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;

const StyledInput = styled.input`
    border-radius: 4px;
    width: 152px;
    border: 1px solid #787878;
    margin: 8px 0;
`;

function ModalDeleteAbono(props: any) {
    const { instance } = useMsal();
    const [justificativa, setJustificativa] = useState("");
    const acessToken = GenericUtils.getAccessTokenDocente();
    const [successMessage, setSuccessMessage] = useState(false);
    const [errorTitle, setErrorTitle] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleClose = () => {
        if (props.onClose) props.onClose();
    };

    const handleSendJustificativa = async () => {
        const response = await axiosPutRequest(
            `/docente/v1/agendas/${props.detail.cartaoAgendaId}/justificar-abono-legal`,
            {
                justificativa,
            },
            acessToken,
            instance
        );

        if (response.status === 204) {
            setSuccessMessage(true);
        } else {
            setErrorTitle("Erro ao Justificar.");
            setErrorMessage(response.data.details);
        }
    };

    const handleCloseDialogSuccess = () => {
        setSuccessMessage(false);
    };

    const dialogSuccess = (
        <DialogMessage
            type="success"
            show={Boolean(successMessage)}
            title="Abono excluído"
            onClose={() => {
                handleCloseDialogSuccess();
                props.onClose?.();
                props?.refreshScheduleCard([props?.detail?.cartaoAgendaId]);
            }}
        />
    );

    const dialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorTitle)}
            title={errorTitle}
            text={errorMessage}
            onClose={() => {
                setErrorTitle("");
                setErrorMessage("");
            }}
        />
    );
    const dataHoraCheckinFormated = StringUtils.formatDateString(
        props.detail?.dataHoraCheckIn,
        "dd/MM/yyyy - HH':'mm"
    );
    const descCheckinAnterior =
        props.detail.statusCheckinAnterior !== undefined
            ? props.detail.statusCheckinAnterior
            : "Check-in realizado";

    const statusDetails = `${descCheckinAnterior} ${
        props.detail.dataHoraCheckIn ? ` - ${dataHoraCheckinFormated}` : ""
    }`;

    return (
        <Dialog
            openModal={props.open}
            onHide={() => {
                handleClose();
                props.onClose?.();
            }}
            size="width-700 modal-white modal-radius-8"
        >
            <StyledModalTitle className="mb-3">Excluir abono</StyledModalTitle>
            <StyledModalText className="mb-3" />
            <Row>
                <Col>
                    <div className="form-floating">
                        <StyledInput
                            className="form-control"
                            id="status"
                            style={{ width: "100%" }}
                            value={statusDetails}
                            disabled
                        />
                        <label htmlFor="Quantidade1">Status do check-in</label>
                    </div>
                </Col>
                <div style={{ height: 20 }} />
                <div>
                    <StyledInfoLabel>Justificativa</StyledInfoLabel>
                    <InputLabelTextArea
                        value={justificativa}
                        placeholder="Insira sua justificativa"
                        onChange={(event: any) =>
                            setJustificativa(event.target.value as string)
                        }
                        viewLengthInfo
                        maxLength={500}
                        style={{
                            height: "107px",
                            borderStyle: "solid",
                            borderColor: "#787878",
                        }}
                    />
                </div>
            </Row>
            <Row>
                <Col className="mt-3" />
            </Row>
            <StyledContainerButton className="mt-3">
                <BtnPrimary
                    disabled={justificativa.length === 0}
                    onClick={handleSendJustificativa}
                >
                    Confirmar
                </BtnPrimary>
            </StyledContainerButton>
            <StyledContainerButton>
                <DefaultButtonLink
                    onClick={() => {
                        props.onClose?.();
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerButton>
            {successMessage && dialogSuccess}
            {errorMessage && dialogError}
        </Dialog>
    );
}

export default ModalDeleteAbono;
